<template>
    <div v-if="!item.hidden">
        <template
            v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
            <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
                <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
                    <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title"/>
                </el-menu-item>
            </app-link>
        </template>
        <template v-else-if="item.meta&&item.meta.isTabPage">
            <el-menu-item :index="resolveTabPath(item)" @click="clickTabs(item)" :class="{'submenu-title-noDropdown':!isNest}">
                <item :title="item.meta.title"/></el-menu-item>
        </template>

        <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body :popper-class="themeColor">
            <template slot="title">
                <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title"/>
            </template>
            <template v-if="!item.meta.isTabPage">
                <sidebar-item
                    v-for="child in item.children"
                    :key="child.path"
                    :is-nest="false"
                    :item="child"
                    :base-path="resolvePath(child.path)"
                    class="nest-menu"
                />
            </template>
        </el-submenu>
    </div>
</template>

<script>
    import path from 'path'
    import {isExternal} from '@/utils/validate'
    import Item from './Item'
    import AppLink from './Link'
    import FixiOSBug from './FixiOSBug'
    import {mapState} from 'vuex'

    export default {
        name: 'SidebarItem',
        components: {Item, AppLink},
        mixins: [FixiOSBug],
        props: {
            // route object
            item: {
                type: Object,
                required: true
            },
            isNest: {
                type: Boolean,
                default: false
            },
            basePath: {
                type: String,
                default: ''
            },
            themeColor:String,
        },
        data() {
            // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
            // TODO: refactor with render function
            this.onlyOneChild = null
            return {}
        },
        computed: {
            ...mapState({
                routes: state => state.permission.routes,
                pageConfig:state => state.user.page_config,
            }),
        },
        methods: {
            hasOneShowingChild(children = [], parent) {

                let parentMeta = parent.meta||{};
                if(parentMeta.isTabPage){
                    return false;
                }

                const showingChildren = children.filter(item => {
                    if (item.hidden) {
                        return false
                    } else {
                        // Temp set(will be used if only has one showing child)
                        this.onlyOneChild = item
                        return true
                    }
                })

                // When there is only one child router, the child router is displayed by default
                if (showingChildren.length === 1) {
                    return true
                }

                // Show parent if there are no child router to display
                if (showingChildren.length === 0) {
                    this.onlyOneChild = {...parent, path: '', noShowingChildren: true}
                    return true
                }

                return false
            },
            resolvePath(routePath) {
                if (isExternal(routePath)) {
                    return routePath
                }
                if (isExternal(this.basePath)) {
                    return this.basePath
                }
                return path.resolve(this.basePath, routePath)
            },
            resolveTabPath(item){
                let child = item.children||[];
                if((item.meta||{}).isTabPage){
                    return path.resolve(item.path);
                }
                return this.resolvePath(child.length>0?child[0].path:'/home');
            },
            clickTabs(item){
                let actionRoute = this._findFieldByName(this.routes,item.name)||{};
                console.log('sidebarItem clickTabs',actionRoute,item);

                if(actionRoute.children&&actionRoute.children.length>0){
                    let child = actionRoute.children[0];
                    console.log('sidebarItem clickTabs child',child);
                    
                    // 只对oppo复制做一次特别处理
                    if(child.name=='oppo_plan_copy'){
                        child.path = '/marketing_management/oppo/oppo_plan_copy/list'
                    }

                    // 处理 综合查询分析-默认平台
                    let dataAnalysisDefaultPlat = this.pageConfig.data_query_analysis_default_plat||''; 
                    // 判断当前默认的tab有没有权限，没有权限则跳转到有权限的第一个tab页
                    let isHasAuth = actionRoute.children.some(item=>item.name==dataAnalysisDefaultPlat);
                    if(child.path.includes('/data_center/data_query_analysis')&&dataAnalysisDefaultPlat&&isHasAuth){
                        child.path = '/data_center/data_query_analysis/'+dataAnalysisDefaultPlat;
                    }

                    this.$router.push({
                        path:child.path,
                    });
                }else{
                    this.$router.push({
                        path:this.resolveTabPath(item),
                    });
                }
            },
            _findFieldByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
        }
    }
</script>
<style scoped lang="scss">
    .nest-menu ::v-deep  .submenu-title-noDropdown{
        height: 38px;
        line-height: 38px;
    }
</style>
